import { render, staticRenderFns } from "./IssueBadgeAction.vue?vue&type=template&id=6ab6a4fd&scoped=true"
import script from "./IssueBadgeAction.vue?vue&type=script&setup=true&lang=js"
export * from "./IssueBadgeAction.vue?vue&type=script&setup=true&lang=js"
import style0 from "./IssueBadgeAction.vue?vue&type=style&index=0&id=6ab6a4fd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab6a4fd",
  null
  
)

export default component.exports